// TODO: Needs a review
/**
 * Component: LoadPage
 * ------------------------------------------------------------------------------
 *
 * @namespace loadPage
 */


/**
 * Export a new store selector instance.
 */
export default () => {

  /**
   * Initialise component.
   */
  function init() {
    // window.setTimeout(() => {
      document.querySelector('#MainContent').classList.add('is-loaded');
      document.querySelector('.cart-ajax__wrapper').classList.add('is-loaded');
    // }, 100);
  }

  /**
   * Expose public interface
   */
  return Object.freeze({
    init,
  });
};
